import { Box } from "@mui/material";

import { TextareaAutosize } from "@mui/material";
import { useTheme } from "@emotion/react";

import { setupManagementUrl } from "../../../config";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import ProductCategoryForm from "./Form";
import { ProductCategoryQuery } from "../../../data/Axios/queries";

const base_url = setupManagementUrl.uri;
const actions = {
  entity: "Product Category",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: true,
    permission: "ActivatePermission",
    modelName: "productCategoryIds",
    inputObjectName: "bulkActivateDeactivateProductCategories",
  },
  AssignTask: {
    key: "ASSIGN_TASK",
    button_name: "Assign Task",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2],
  },
  showStatus:true,
};
function ProductCategoryTable() {
 // const ignore = ["isActive"];
  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="Product Category"
          subtitle="Manage Product Category"
       //   ignoreFields={ignore}
          FormComponent={ProductCategoryForm}
          query={ProductCategoryQuery}
          base_url={base_url}
          actions={actions}
        />
      </>
    </Box>
  );
}

export default ProductCategoryTable;
